import React from "react";

import { Box, Chip, Stack } from "@mui/material";

import {
  ENV_COLORS,
  ENV_KEYS,
  ENV_LABELS,
  EnvKey,
} from "./editable-services-constants";

// ── Environment Tabs (chip-based env switcher) ───────────────────────────────

export interface EnvironmentTabsProps {
  activeEnv: EnvKey;
  envsWithOverrides: Set<EnvKey>;
  onChange: (env: EnvKey) => void;
}

export function EnvironmentTabs({
  activeEnv,
  envsWithOverrides,
  onChange,
}: EnvironmentTabsProps): React.ReactElement {
  return (
    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
      {ENV_KEYS.map((env) => (
        <Chip
          key={env}
          label={ENV_LABELS[env]}
          variant={activeEnv === env ? "filled" : "outlined"}
          color={activeEnv === env ? ENV_COLORS[env] : "default"}
          onClick={() => onChange(env)}
          icon={
            envsWithOverrides.has(env) ? (
              <Box
                component="span"
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: "warning.main",
                  display: "inline-block",
                  ml: "4px",
                }}
              />
            ) : undefined
          }
          sx={{
            cursor: "pointer",
            ...(activeEnv === env && { fontWeight: 600 }),
          }}
        />
      ))}
    </Stack>
  );
}

export default EnvironmentTabs;
